var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#003359"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.779 13.976-14.319 7.16c-1.59.795-3.46-.361-3.46-2.138v-13.99602c0-1.777 1.87-2.933 3.459-2.138l14.319 7.16002c1.629.814 1.629 3.138.001 3.952z",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.4242 12.67-12.42501 2.33-1.252-1.252c-.965002-.965-.965002-2.531 0-3.496l1.252-1.252 12.42501 2.33c.742.139.742 1.201 0 1.34z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.cc26a94fe6a14f448d3fd69fcb890188.svg";
export { ForwardRef as ReactComponent };